{
  "brand": "Aruba Animal Radar",
  "tagline": "Dosiernan di animal di kaya — miramentonan, animal perdí, chip.",
  "nav": {
    "map": "Mapa",
    "addSighting": "Agrega miramento",
    "reportLost": "Reportá perdí",
    "searchChip": "Buska chip",
    "login": "Drenta",
    "logout": "Sali"
  },
  "panel": {
    "title": "Kasonan aktivo",
    "lostTitle": "Perdí atualmente",
    "emptyLost": "No tin report di animal perdí aktivo.",
    "openPanel": "Dosiernan",
    "closePanel": "Serra",
    "sightings": "Miramentonan",
    "related": "Miramentonan linkiá",
    "stepPrev": "Miramento anterior",
    "stepNext": "Próximo miramento"
  },
  "fields": {
    "type": "Tipo",
    "breed": "Rasa",
    "color1": "Koló primário",
    "color2": "Koló sekundário",
    "color3": "Di tres koló",
    "chip": "Microchip",
    "spayed": "Kastrá / Esterilizá",
    "ownership": "Status di dueño",
    "ifFound": "Si haña, kontakto",
    "notes": "Notanan",
    "location": "Lokashon",
    "sightedAt": "Mirá na",
    "contact": "Informashon di kontakto",
    "unknown": "Deskonosí",
    "none": "Ningun",
    "other": "Otro"
  },
  "types": {
    "dog": "Kachó",
    "cat": "Pushi",
    "other": "Otro"
  },
  "colors": {
    "black": "Pretu",
    "white": "Blanku",
    "brown_chocolate": "Bruin / Chocolade",
    "tan_fawn": "Beige / Fawn",
    "red_orange": "Kora / Oranje",
    "gray_blue": "Gris / Blauw",
    "cream_yellow": "Crema / Geel",
    "gold_apricot": "Oru / Abrikoos"
  },
  "ownership": {
    "confirmed_owned": "Dueño konfirmá",
    "confirmed_abandoned": "Abandoná konfirmá",
    "no_known_owner": "Sin dueño konosí",
    "reported_lost": "Reportá komo perdí"
  },
  "spayed": {
    "yes": "Sí",
    "no": "Nò",
    "unknown": "Deskonosí"
  },
  "actions": {
    "submit": "Manda",
    "cancel": "Kanselá",
    "search": "Buska",
    "link": "Linkiá miramentonan",
    "unlink": "Deslinkiá for di animal",
    "save": "Guarda",
    "pickOnMap": "Skoge riba mapa"
  },
  "forms": {
    "addSightingTitle": "Registrá un miramento",
    "reportLostTitle": "Reportá animal perdí",
    "chipSearchTitle": "Buskeda di chip",
    "chipPlaceholder": "Pone number di microchip",
    "breedOtherHint": "Por agrega rasa nobo ora di reportá un animal perdí.",
    "noResults": "No a haña resultado."
  },
  "lang": {
    "label": "Idioma",
    "en": "English",
    "es": "Español",
    "pap": "Papiamento",
    "nl": "Nederlands"
  },
  "status": {
    "loading": "Kargando…",
    "mapLoading": "Inisialisando mapa…",
    "error": "Algo a bai malu."
  }
}
